import {
  CalculatePrice,
  SubscriptionPeriod
} from '@anm/api/modules/subscription';

export const getCalculatePrice = (
  prices: CalculatePrice[],
  forPeriod: SubscriptionPeriod
) => prices.find(({ period }) => period === forPeriod) as CalculatePrice;
